import { createLazyReactDirective } from '../../shell/ng';

export default createLazyReactDirective(
  async () => (await import('./LoanSettingsList')).LoanSettingsList,
  'loanSettingsList',
);
